import React from "react";

type TabProps = {
  title: string;
  children: React.ReactNode;
};

export const Tab: React.FC<TabProps> = ({ children }) => {
  return <div>{children}</div>;
};
